import { useState, useCallback } from 'react';
import { message } from 'antd';
import { g305Api, QueryParams, ReportRow, CurrencySummary, GroupCount, DelayStats } from '../../../services/g305Api';

export function useG305Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReportRow[]>([]);
  const [currencySummary, setCurrencySummary] = useState<CurrencySummary[]>([]);
  const [twdTotal, setTwdTotal] = useState<number>(0);
  const [groupCounts, setGroupCounts] = useState<GroupCount[]>([]);
  const [delayStats, setDelayStats] = useState<DelayStats[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await g305Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setCurrencySummary(resp.currency_summary || []);
        setTwdTotal(resp.twd_total || 0);
        setGroupCounts(resp.group_counts || []);
        setDelayStats(resp.delay_stats || []);
        setNoData(false);
      } else {
        setData([]);
        setCurrencySummary([]);
        setTwdTotal(0);
        setGroupCounts([]);
        setDelayStats([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setCurrencySummary([]);
    setTwdTotal(0);
    setGroupCounts([]);
    setDelayStats([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, currencySummary, twdTotal, groupCounts, delayStats, queried, noData, runQuery, reset };
}
